import { PresentationStatus } from './types';

type PermissionKind = 'edit' | 'approve';

const TRANSITIONS: Record<string, PermissionKind> = {
  'draft:review': 'edit',
  'review:draft': 'edit',
  'review:ready': 'approve',
  'ready:draft': 'approve',
  'ready:review': 'approve',
};

export function hasPresentationAdmin(permissions: string[] = []): boolean {
  return permissions.includes('presentations:admin') || permissions.includes('admin:all');
}

export function allowedStatusTransitions(from: PresentationStatus, permissions: string[]): PresentationStatus[] {
  return (['draft', 'review', 'ready'] as PresentationStatus[]).filter((to) => {
    const rule = TRANSITIONS[`${from}:${to}`];
    if (!rule) return false;
    if (hasPresentationAdmin(permissions)) return true;
    if (rule === 'edit') return permissions.includes('presentations:edit');
    return permissions.includes('presentations:approve');
  });
}

export function statusActionLabel(from: PresentationStatus, to: PresentationStatus, copy: {
  sendToReview: string;
  backToDraft: string;
  markReady: string;
  backToReview: string;
}): string {
  if (from === 'draft' && to === 'review') return copy.sendToReview;
  if (to === 'draft') return copy.backToDraft;
  if (from === 'review' && to === 'ready') return copy.markReady;
  return copy.backToReview;
}
